import { render, staticRenderFns } from "./BranchAutocomplete.vue?vue&type=template&id=52227c16&"
import script from "./BranchAutocomplete.vue?vue&type=script&lang=js&"
export * from "./BranchAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports